export const onBodyEvent = (event: string, callback: (ev: any) => any) => {
  onMounted(() => document.body.addEventListener(event, callback))
  onUnmounted(() => document.body.removeEventListener(event, callback))
}
